import themeChooser from "../../../../content/blog/assets/theme-chooser.png";
import * as React from 'react';
export default {
  themeChooser,
  React
};